import actionTypes from './actionTypes'

const characterSelected = (id: string) => {
	return {
		type: actionTypes.CHARACTERS_SELECT,
		id,
	}
}

export default {
	characterSelected,
}
